// extracted by mini-css-extract-plugin
module.exports = {"root":"TitleBlock_root__SLubm","iconWrap":"TitleBlock_iconWrap__bOHXT","contentWrap":"TitleBlock_contentWrap__3xBuy","title":"TitleBlock_title__15hyZ"};